import { render, staticRenderFns } from "./BusquedaLugarDespacho.vue?vue&type=template&id=1c2b024e&scoped=true"
import script from "./BusquedaLugarDespacho.vue?vue&type=script&lang=js"
export * from "./BusquedaLugarDespacho.vue?vue&type=script&lang=js"
import style0 from "./BusquedaLugarDespacho.vue?vue&type=style&index=0&id=1c2b024e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c2b024e",
  null
  
)

export default component.exports